export const rightsRequestsCounts = {
    APPROVED: 0,
    CANCELLED: 0,
    DENIED: 0,
    EXISTING_PUBLISHERS: 0,
    NEEDS_MATCH: 0,
    NEW: 0,
    NEW_PUBLISHERS: 0,
    NP_NEW: 0,
    NP_PROCESSING: 0,
    NP_WAITING_LEGAL: 0,
    ONBOARDING: 0,
    ON_HOLD: 0,
    PROCESSING: 0,
    WAITING_CUSTOMER: 0,
    WAITING_INSTITUTION: 0,
    WAITING_LEGAL: 0,
    WAITING_PUBLISHER: 0
};

export default {
    ADD_RIGHTS: 0,
    AVAILABLE: 0,
    DENIED: 0,
    FULFILLMENT: 0,
    NEEDS_ATTENTION: 0,
    NOT_FOUND: 0,
    PENDING: 0,
    PUBLISHER_REVIEW: 0,
    PURGATORY: 0,
    REQUEST: 0,
    REQUESTED: 0,
    REQUEST_RIGHTS: 0,
    RETIRED: 0,
    SUBMITTED: 0,
    SUBSTITUTED: 0,
    TOTAL: 0,
    UNAVAILABLE: 0
}